<template>
  <div class="space-y-4 pt-6">
    <div class="flex items-center justify-between">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="data.investment_name"
          class="text-xl font-semibold text-ontick-steel-900 dark:text-gray-300 sm:text-3xl"
        >
          {{ data.investment_name }}
        </h2>
      </transition>
    </div>
    <div>
      <transition name="slide-fade" mode="out-in">
        <span
          :key="data.investment_type"
          :class="colorStatus(data.investment_type)"
          class="rounded-md px-4 py-0"
          >{{ data.investment_type }}</span
        >
      </transition>
    </div>
    <div class="h-full pr-3">
      <charts :charts="menu_charts" :investment_data="data" />
    </div>
  </div>
</template>

<script>
import Roller from "vue-roller";
import charts from "@/app/modules/performance/shared/components/charts.component";

export default {
  name: "performance-strategy",
  components: {
    charts,
    Roller,
  },

  data() {
    return {
      menu_charts: [
        { label: "Linha", active: true },
        { label: "Barra", active: false },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    colorStatus(value) {
      let color = "";
      if (value == "STRATEGY") {
        color = `bg-ontick-orange-900 text-ontick-orange-500`;
      } else if (value == "PORTFOLIO") {
        color = `bg-ontick-lime-900 text-ontick-lime-500`;
      } else if (value == "SIGNAL") {
        color = `bg-ontick-blue-900 text-ontick-blue-500`;
      }
      return color;
    },
  },
};
</script>

<style lang="scss" scoped></style>
